import { ModuleTypeIcon } from './module-type-icon';

/** Shared module name presentation. Unknown types remain unmarked. */
export function ModuleLabel({ name, managed }: { name: string; managed?: boolean }) {
    return <span className="inline-flex align-items-center gap-2">
        {managed !== undefined && <ModuleTypeIcon managed={managed} />}<span>{name}</span>
    </span>;
}
